let frFocus = () => {
	return {
		link: function ($scope, $element, $attributes) {
			$attributes.$observe('frFocus', function (value) {
				if (value)
					$element[0].focus();
			});
		}
	};
};
export default frFocus;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/directives/fr-focus.directive.js